module.exports = __webpack_public_path__ + "img/teste.cc87bbea.jpg";